const ACCOUNT_GA_MEASUREMENT_ID = (process.env.REACT_APP_ACCOUNT_GA_MEASUREMENT_ID || '').trim();

let initialized = false;

export const initAccountAnalytics = () => {
  if (!ACCOUNT_GA_MEASUREMENT_ID || initialized || typeof window === 'undefined') return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag(){ window.dataLayer.push(arguments); };

  const existingScript = document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${ACCOUNT_GA_MEASUREMENT_ID}"]`);
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ACCOUNT_GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', ACCOUNT_GA_MEASUREMENT_ID, {
    send_page_view: false,
  });
  initialized = true;
  return true;
};

export const trackAccountPageView = (pathname) => {
  if (!ACCOUNT_GA_MEASUREMENT_ID || !initialized || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: pathname || window.location.pathname,
    page_title: document.title,
  });
};
